<template>
    <div class="wrapper-popup" v-if="event">
        <div class="card-popup">
            <a class="button-close" @click="$emit('close', true)">
                <svg xmlns="http://www.w3.org/2000/svg" height="20" width="15" viewBox="0 0 384 512">
                    <path
                        d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
                </svg>
            </a>
            <div class="card-body">
                <p>Apakah Anda Akan Melanjutkan Registrasi Untuk <br><strong>{{ event.name }}, {{ event.province }}</strong>?</p>
                <div class="button-wrapper">
                    <div class="button">
                        <a
                            @click="trackerJoinEvent(event, 'Notif Verification Join Event - Honda Bikers Day Regional')"
                            :href="app_url + '/event'"
                            class="btn btn-white mr-auto"
                        >
                            Honda Bikers Day Regional
                        </a>
                    </div>
                    <div class="button">
                        <a @click="confirm" class="btn btn-red mr-auto">Lanjutkan</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['event'],

    data() {
        return {
            agreeConfirm: false,
            app_url: app_url
        }
    },
    methods: {
        trackerJoinEvent(event, action) {
            let data = {
                'event': 'joinEvent',
                'eventDetail.category': 'Join Event Community',
                'eventDetail.action': action,
                'eventName': event.name,
                'id': event.id,
                'eventType': event.type,
                'startDate': event.start_date,
                'endDate': event.end_date,
                'publishedDate': event.created_at,
                'province': event.province,
            }
            // console.log('joinEvent tracker popup = ', data)
            dataLayer.push(data);
        },
        confirm() {
                this.agreeConfirm = true;
                this.$emit('continue');
                this.trackerJoinEvent(this.event, 'Notif Verification Join Event - Lanjutkan');

        }
    }
}
</script>
<style lang="scss" scoped>
.wrapper-popup {
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    background-color: rgba(21, 21, 21, 0.8);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;

    .card-popup {
        position: relative;
        background-color: #fff;
        border-radius: 10px;
        padding: 20px;
        width: 90%;
        max-width: 558px;
        height: auto;
        max-height: 90vh;
        overflow-y: auto;


        .button-close {
            position: absolute;
            left: auto;
            right: 15px;
        }

        .card-body {
            text-align: center;
            color: rgba(40, 40, 40, 1);
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            p {
                color: #333;
                font-size: 18px;
                width: 100%;
                max-width: 100%;
                margin-bottom: 55px;
                line-height: 1.4;
                word-wrap: break-word;
            }

            .button-wrapper {
                display: flex;
                align-items: center;
                justify-content: center;

                .button {
                    margin: 5px 10px;
                    width: calc(50% - 20px);
        
                    padding-top: 15px;
                    margin-left: 6px;
                        margin-right: 6px;
                        width: 100%;
        
                    .btn {
                        width: 100%;
                        max-width: 100%;
                        font-weight: 700;
                        font-size: 14px;
                        padding: 10px;
                        height: 42px;
                        border-radius: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
        
                        &:hover {
                            background-color: #333 !important;
                            color: #fff;
                        }
                    }

                    .btn-white {
                        background-color: #fff;
                        color: #E61B33;
                        border: 1px solid #DBDBDB;
                    }
                }
            }


            .red-button {
                background-color: #E61B33;
                color: #fff;
                padding: 10px 20px;
                border-radius: 10px;
                font-weight: 700;
                font-size: 14px;
                display: inline-block;
                cursor: pointer;
            }
        }
    }

}

@media (max-width: 768px) {
    .wrapper-popup {
        .card-popup {
            padding: 15px;
            max-width: 90%;
        }

        .card-body {
            p {
                font-size: 14px;
                margin-bottom: 15px;
                word-wrap: break-word;
            }

            .button-wrapper {
                flex-direction: column;

                .button {
                    padding-top: 0 !important;
                    width: 100% !important;
                }
            }
        }
    }
}
</style>
